import { ImageFileId } from '../image/image-file-id'
import React from 'react'
import { CommunityComment, CommunityReply } from 'src/types/community'
import { stringUtil } from 'src/util/string-util'
import { timeUtil } from 'src/util/time-util'

interface CommentItemProps {
  comment: CommunityComment | CommunityReply
  onReply?: () => void
  small?: boolean
}

export const CommentItem = ({ comment, onReply, small }: CommentItemProps): React.ReactElement => {
  return (
    <div className="flex gap-3">
      <div
        className={`flex flex-shrink-0 items-center justify-center rounded-full bg-white/10 font-semibold text-white ${
          small ? 'h-6 w-6 text-[10px]' : 'h-8 w-8 text-xs'
        }`}
      >
        {comment.hustler?.profilePhotoFileId ? (
          <ImageFileId
            fileId={comment.hustler.profilePhotoFileId ?? ''}
            className={`rounded-full object-cover ${small ? 'h-6 w-6' : 'h-8 w-8'}`}
          />
        ) : (
          stringUtil.initials(stringUtil.getDisplayName(comment.hustler) ?? '')
        )}
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-baseline gap-2">
          <span className={`font-bold text-white uppercase ${small ? 'text-xs' : 'text-sm'}`}>
            {stringUtil.getDisplayName(comment.hustler ?? null)}
          </span>
          <span className={`text-white/40 ${small ? 'text-[10px]' : 'text-xs'}`}>
            {timeUtil.formatRelativeTime(comment.createdAt)}
          </span>
        </div>
        <p className={`mt-0.5 whitespace-pre-wrap text-white/80 ${small ? 'text-xs' : 'text-sm'}`}>{comment.text}</p>
        {onReply && (
          <button type="button" className="mt-1 text-xs font-semibold text-white/40 hover:text-white/60" onClick={onReply}>
            Reply
          </button>
        )}
      </div>
    </div>
  )
}
